export const CONTENTFUL_SECTION_SW_BILLING_ACCOUNTS = 'ContentfulSectionSwBillingAccounts';

export { default } from './SWBillingAccounts';
